"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThrottle = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
var useDeepEqualMemo_1 = require("../useDeepEqualMemo");
/**
 * Returns a throttled version of the passed function.
 * Make sure your dep array is correct, linter doesn't work for custom hooks!!
 **/
function useThrottle(func, dependencies, delay, options) {
    // memoize options so they don't throw off the throttle memo
    var memoizedOptions = (0, useDeepEqualMemo_1.useDeepEqualMemo)(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttledFunction = (0, react_1.useMemo)(function () { return (0, throttle_1.default)(func, delay, memoizedOptions); }, tslib_1.__spreadArray(tslib_1.__spreadArray([], dependencies, true), [
        delay,
        memoizedOptions,
    ], false));
    (0, react_1.useEffect)(function () {
        return function () {
            throttledFunction.cancel();
        };
    }, [throttledFunction]);
    return throttledFunction;
}
exports.useThrottle = useThrottle;
//# sourceMappingURL=useThrottle.js.map